var React = require('react');

function ChevronCircleUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm152.5 303.5l-17 17a23.9 23.9 0 0 1-33.9 0L256 226.9 154.4 328.5a23.9 23.9 0 0 1-33.9 0l-17-17a23.9 23.9 0 0 1 0-33.9L239 142.1a24 24 0 0 1 34 0l135.5 135.5a23.9 23.9 0 0 1 0 33.9z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M273 142.1l135.5 135.5a23.9 23.9 0 0 1 0 33.9l-17 17a23.9 23.9 0 0 1-33.9 0L256 226.9 154.4 328.5a23.9 23.9 0 0 1-33.9 0l-17-17a23.9 23.9 0 0 1 0-33.9L239 142.1a24 24 0 0 1 34 0z","className":"fa-primary","key":2})]);
}

ChevronCircleUp.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ChevronCircleUp;

ChevronCircleUp.default = ChevronCircleUp;
